import { z } from "zod/v4-mini";

import { Gender, genderSchema } from "@/models/GenderModel.ts";
import { Schema, cz } from "@/utils/zodUtils.ts";

export const identityStatusSchema = z.literal(["notValidated", "validated", "rejected", "notEntered"]);
export type IdentityStatus = z.infer<typeof identityStatusSchema>;

export type ValidateOrRejectIdentity = "validate" | "reject";

export type InseeTownship = {
  town: string;
  postCode: string;
};

export type FrenchIdentity = {
  identityStatus: IdentityStatus;

  identityLastname?: string;
  identityFirstnames: string[];
  gender?: Gender;
  birthDate?: string;
  ins?: string;
  oid?: string;
  socialSecurityNumber?: string;
  birthLocation?: InseeTownship;
  birthCountry?: string;
};

export const frenchIdentitySchema: Schema<FrenchIdentity> = z.pipe(
  z.object({
    identityLastname: cz.optional(z.string()),
    identityFirstnames: cz.forcedArray(z.string()),
    gender: cz.optional(genderSchema),
    identityStatus: identityStatusSchema,
    birthLocation: cz.optional(
      cz.camelCaseObject({
        town: z.string(),
        post_code: z.string(),
      }),
    ),
    birthCountry: cz.optional(z.string()),
    birthDate: cz.optional(z.string()),
    franceINS: cz.optional(z.string()),
    franceOID: cz.optional(z.string()),
    socialSecurityNumber: cz.optional(z.string()),
  }),
  z.transform(data => ({
    ...data,
    ins: data.franceINS,
    oid: data.franceOID,
  })),
);

export const inseeTownshipToString = (inseeTownship: InseeTownship) => {
  return `${inseeTownship.town} (${inseeTownship.postCode})`;
};
